import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExceptionDates } from 'planning-portal-library/src/lib/core/domain/models/scheduler/exception-dates';
import { PlanScheduled } from 'planning-portal-library/src/lib/core/domain/models/scheduler/plan-scheduled';
import { PlanScheduledRequest } from 'planning-portal-library/src/lib/core/domain/requests/plans/get-scheduled-plans-request';
import { CreateSchedulerInstanceRequest } from 'planning-portal-library/src/lib/core/domain/requests/Scheduler/create-scheduler-instance';
import { UpdateSchedulerInstanceRequest } from 'planning-portal-library/src/lib/core/domain/requests/Scheduler/update-scheduler-instance-request';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { PlanScheduledRepository } from 'planning-portal-library/src/lib/core/repositories/scheduler.repository';
import { catchError, map, mergeMap, Observable, reduce } from 'rxjs';
import { BaseResponse } from '../../shared/base.response';
import { SchedulerApiUrls } from './scheduler-api-urls';

@Injectable({ providedIn: 'root' })
export class PlanScheduledWebRepository extends PlanScheduledRepository {
  private readonly environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }

  getPlanScheduled(request: PlanScheduledRequest): Observable<PlanScheduled[]> {
    return this.http
      .post<BaseResponse<PlanScheduled[]>>(
        `${this.environment.url}${SchedulerApiUrls.GetPlansScheduled}`,
        request
      )
      .pipe(
        mergeMap((response: BaseResponse<PlanScheduled[]>) => response.result!),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(
        reduce(
          (items: PlanScheduled[], item: PlanScheduled) => [...items, item],
          []
        )
      );
  }

  updateSchedulerInstance(
    request: UpdateSchedulerInstanceRequest
  ): Observable<boolean> {
    return this.http
      .put<BaseResponse<boolean>>(
        `${this.environment.url}${SchedulerApiUrls.UpdateSchedulerInstance}`,
        request
      )
      .pipe(
        map((data) => {
          return data.result!;
        })
      );
  }

  createSchedulerInstance(
    request: CreateSchedulerInstanceRequest
  ): Observable<ExceptionDates> {
    return this.http
      .post<BaseResponse<ExceptionDates>>(
        `${this.environment.url}${SchedulerApiUrls.CreateSchedulerInstance}`,
        request
      )
      .pipe(
        map((response: BaseResponse<ExceptionDates>) => response.result!),
        catchError((err) => {
          throw err;
        })
      );
  }

  removeSchedulerInstance(request: any): Observable<ExceptionDates> {
    return this.http
      .post<BaseResponse<ExceptionDates>>(
        `${this.environment.url}${SchedulerApiUrls.RemoveSchedulerInstance}`,
        request
      )
      .pipe(
        map((response: BaseResponse<ExceptionDates>) => response.result!),
        catchError((err) => {
          throw err;
        })
      );
  }
}
